// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBlqaO0U_ACyYkZJD4e_P3RcWhcQK7LYHs",
  authDomain: "chipla-57c12.firebaseapp.com",
  projectId: "chipla-57c12",
  storageBucket: "chipla-57c12.appspot.com",
  messagingSenderId: "961367743558",
  appId: "1:961367743558:web:617302ef0c8b92a6c67e47",
  measurementId: "G-MV78YMYZ1W"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// init firestore service
export const db = getFirestore()
// export default db


